
export enum TransferStatusEvent {

  WILLPROCESSON,

  POSTEDON,

  NOFUNDSON,

  CANCELEDON,

  FAILEDON
}
